import { Logo } from "../brand/Logo";

export function LoadingScreen() {
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flex: 1 }}>
      <div style={{ opacity: 0.8 }}>
        <Logo size={48} />
      </div>
    </div>
  );
}
